<template>
  <!-- CARD -->
  <div class="card" v-if="viewType === 'brilliant'">
    <header class="card-header compact">
      <p class="card-header-title compact tags">
        <a v-on:click="runAction3(type)" target="_blank" class="tag is-light">{{ type }}</a>
        <a v-on:click="runAction3(group)" target="_blank" class="tag is-light">{{ group }}</a>
        
        <a
          v-on:click="runAction3(versionText)"
          target="_blank"
          class="tag is-light"
        >{{ versionText }}</a>
        <a
          v-on:click="runAction3(userFullName)"
          target="_blank"
          class="tag is-light"
        >{{ userFullName }}</a>
      </p>

      <div
        class="card-header-title compact mouse-detrav-hover"
        style="justify-content: space-between;"
      >
        <div></div>
        <div class="tags compact">
          <a
            v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'"
            v-on:click="runAction1"
            class="tag is-dark"
          >{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
          <a
            v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'"
            v-on:click="runAction2"
            class="tag is-dark"
          >{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
        </div>
      </div>
    </header>
    <div class="card-content compact">
      <div class="content" style="margin:0; background-color:white">
        <p v-if="translation">{{ translation.text }}</p>
      </div>
    </div>
  </div>
  <div class="card" v-else-if="viewType === 'deluxe'">
    <header class="card-header compact">
      <p class="card-header-title compact">
        <a
          v-on:click="runAction3(versionText)"
          target="_blank"
          class="has-text-black"
        >Version: {{ versionText }}</a>
      </p>
      <p class="card-header-title compact">
        <a v-on:click="runAction3(type)" target="_blank" class="has-text-black">Type: {{ type }}</a>
      </p>
      <p class="card-header-title compact">
        <a v-on:click="runAction3(group)" target="_blank" class="has-text-black">Group: {{ group }}</a>
      </p>
      <p class="card-header-title compact">
        <a
          v-on:click="runAction3(userFullName)"
          target="_blank"
          class="has-text-black"
        >Author: {{ userFullName }}</a>
      </p>
    </header>
    <div class="card-content compact">
      <div class="content" style="margin:0; background-color:white">
        <p v-if="translation">{{ translation.text }}</p>
      </div>
    </div>
    <footer class="card-footer">
      <!-- <a v-bind:href="taskLink" class="card-footer-item compact has-black">Task</a>
        <a v-bind:href="mergeRequestLink" class="card-footer-item compact has-black">Merge</a>
        <a v-bind:href="documentationLink" class="card-footer-item compact has-black">Docs</a>
      <a class="card-footer-item compact has-black"><input type="checkbox" disabled v-model="isPrivate">Private</a>-->
      <a
        v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'"
        v-on:click="runAction1"
        class="card-footer-item compact has-black"
      >{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
      <a
        v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'"
        v-on:click="runAction2"
        class="card-footer-item compact has-black"
      >{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
    </footer>
  </div>
  <b-collapse class="card" :open="isExpandedCard" v-else>
    <div slot="trigger" slot-scope="props" :open="false" class="card-header">
      <div
        v-if="isExpandedCard"
        v-on:click="isExpandedCard = !isExpandedCard"
        style="display: flex; flex-direction: row; width: -webkit-fill-available;"
      >
        <p class="card-header-title">
          <a
            v-on:click="runAction3(versionText)"
            target="_blank"
            class="has-text-black"
          >Date: {{ date }}</a>
        </p>
        <p class="card-header-title">
          <a
            v-on:click="runAction3(versionText)"
            target="_blank"
            class="has-text-black"
          >Version: {{ versionText }}</a>
        </p>
        <p class="card-header-title">
          <a v-on:click="runAction3(type)" target="_blank" class="has-text-black">Type: {{ type }}</a>
        </p>
        <p class="card-header-title">
          <a
            v-on:click="runAction3(group)"
            target="_blank"
            class="has-text-black"
          >Group: {{ group }}</a>
        </p>
        <p class="card-header-title">
          <a
            v-on:click="runAction3(userFullName)"
            target="_blank"
            class="has-text-black"
          >Author: {{ userFullName }}</a>
        </p>
        <p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon>
          </a>
        </p>
      </div>
      <div
        v-else
        v-on:click="isExpandedCard = !isExpandedCard"
        style="display: flex; flex-direction: row; width: -webkit-fill-available;"
      >
        <p class="card-header-title compact tags">
          <a
            v-on:click="runAction3(date)"
            target="_blank"
            class="tag is-light"
            style="min-width:80px;"
          >{{ date }}</a>
          <a
            v-on:click="runAction3(versionText)"
            target="_blank"
            class="tag is-light"
            style="min-width:105px;"
          >{{ versionText }}</a>
          <a
            v-on:click="runAction3(type)"
            target="_blank"
            class="tag is-light"
            style="min-width:105px;"
          >{{ type }}</a>
          <a
            v-on:click="runAction3(group)"
            target="_blank"
            class="tag is-light"
            style="min-width:105px;"
          >{{ group }}</a>
          
          <a
            v-on:click="runAction3(userFullName)"
            target="_blank"
            class="tag is-light"
            style="min-width:105px;"
          >{{ userFullName }}</a>
        </p>
        <p class="clipped-text" v-if="translation">{{ translation.text }}</p>
        <p>
          <a class="card-header-icon">
            <b-icon :icon="props.open ? 'menu-up' : 'menu-down'"></b-icon>
          </a>
        </p>
      </div>
    </div>
    <div class="card-content">
      <div class="content">
        <p v-if="translations" v-for="(translation, index) in translations" :key="index">
          {{ translation.text }}
          <span
            v-if="!!translation && !!translation.annotation && translation.annotation.length > 0"
          >( {{ translation.annotation }} )</span>
        </p>
      </div>
      <nav class="level">
        <p class="level-item has-text-centered">
          <a class="link is-info" v-bind:href="taskLink">Task Link</a>
        </p>
        <p class="level-item has-text-centered">
          <a class="link is-info" v-bind:href="mergeRequestLink">Merge Request Link</a>
        </p>
        <p class="level-item has-text-centered">
          <a class="link is-info" v-bind:href="documentationLink">Documentation Link</a>
        </p>
        <label class="checkbox">
          <input type="checkbox" disabled v-model="isPrivate"> Private change
        </label>
      </nav>
    </div>
    <footer class="card-footer">
      <a
        v-if="(action1 != null && action1.length > 0) && this.userRole != 'readonly'"
        v-on:click="runAction1"
        class="card-footer-item"
      >{{ action1.charAt(0).toUpperCase() + action1.substr(1) }}</a>
      <a
        v-if="(action2 != null && action2.length > 0) && this.userRole != 'readonly'"
        v-on:click="runAction2"
        class="card-footer-item"
      >{{ action2.charAt(0).toUpperCase() + action2.substr(1) }}</a>
    </footer>
  </b-collapse>
  <!-- END CARD -->
</template>

<script>
//import this.HTTP from "./Http";

import { getVersionText } from "./Utils";

const groupKey = {
  name: "default"
};

export default {
  name: "change-card",
  props: {
    action1: String, //Edit
    action2: String, //Delete
    action3: String, //search
    change: Object,
    isExpandedCard: Boolean
  },
  data() {
    return {
      userName: "Johnessa",
      userFamilyName: "Doe",
    };
  },
  computed: {
    id: function() {
      return this.change.id;
    },
    date: function() {
      let date = new Date(this.change.createDate);
      return (
        date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear()
      );
    },
    version: function() {
      return this.change.version;
    },
    type: function() {
      return this.change.type;
    },
    group: function() {
      return (this.change.group || groupKey).name;
    },
    userFullName: function() {
      if (this.change.user != null)
        return this.change.user.name + " " + (this.change.user.familyName ? this.change.user.familyName : ""); // + " " + this.change.user.familyName;
      else return "John Doe";
    },
    documentationLink: function() {
      return this.change.translations[0].documentationLink;
    },
    translation: function() {
      let translations = this.change.translations;
      console.log(translations);
      for (let translation of translations) {
        if (translation.language == "English") return translation;
      }
      for (let translation of translations) {
        return translation;
      }
      return null;
    },
    translations: function() {
      return this.change.translations;
    },
    isPrivate: function() {
      return this.change.isPrivate;
    },
    taskLink: function() {
      return this.change.taskLink;
    },
    mergeRequestLink: function() {
      return this.change.mergeRequestLink;
    },
    userLink: function() {
      return process.env.PASSPORT_URI + "/Profile/Index/" + this.change.userId;
    },
    versionText: function() {
      return getVersionText(this.change.version);
    }
  },
  methods: {
    runAction1() {
      this.$emit(this.action1, this.id);
    },
    runAction2() {
      this.$emit(this.action2, this.id);
    },
    runAction3(searchingText) {
      this.$emit(this.action3, searchingText);
    }
  }
};
</script>


<style>
.compact.card-header {
  background-color: whitesmoke;
}

.compact.card-header-title {
  padding-top: 1px;
  padding-bottom: 1px;
}

.compact.card-content {
  padding: 0.75rem 1.5rem;
}

.compact.card-footer-item {
  padding-top: 0;
  padding-bottom: 0;
}

.is-info.card-footer-item {
  background-color: hsl(204, 86%, 53%);
  color: white;
}

.is-danger.card-footer-item {
  background-color: hsl(348, 100%, 61%);
  color: white;
}

.has-black.card-footer-item {
  color: black;
}

.compact.tags:not(:last-child) {
  margin-bottom: 0;
}

.compact.tags {
  margin-bottom: 0;
  flex-wrap: nowrap;
  flex-grow: 0;
}

.compact .tag {
  margin-bottom: 0;
}

.card .mouse-detrav-hover {
  display: none;
}

.card:hover .mouse-detrav-hover {
  display: flex;
}

.clipped-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  margin: auto;
  flex-grow: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/ChangeCard.Vue